const phoneInputRegex = /^$|^[\d \-+()]+$/i;

export const isPhoneInputValid = (value: string): boolean => phoneInputRegex.test(value);
